module.exports = __webpack_public_path__ + "media/images/icon/chevron-right-black-fd4172f61901ea1e82276e8b2c9860b1.svg";